import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router';
import MediaQuery from 'react-responsive';

import mea from '../../../services/mea';
import {
    completeOnlineMeasWithAvailablePartners,
    completeOfflineMeasWithAvailablePartners,
    completeEbonMeasWithAvailablePartners
} from '../../../services/mea/utils';

import { LoadingComponent } from '../../loading/LoadingComponent';
import PartnerBlockComponent from '../../partner/PartnerBlockComponent';

const DesktopMeaOfferSelection = ({
    isOnline,
    isOffline,
    isEbon,
    i18nHome,
    partners,
    ebonPartners,
    ebonPartnersFetching,
    onlineOffers,
    offlineOffers,
    ebonOffers
}) => {
    const hasOffer = () => {
        if (isOnline && partners && onlineOffers && onlineOffers.length > 0) {
            return true;
        } else if (isOffline && partners && offlineOffers && offlineOffers.length > 0) {
            return true;
        } else if (isEbon && ebonOffers && ebonOffers.length > 0) {
            return true;
        } else {
            return false;
        }
    };

    const getTitle = () => {
        if (isOnline) {
            return i18nHome.ONLINE_OFFERS_SELECTION_TITLE;
        } else if (isOffline) {
            return i18nHome.OFFLINE_OFFERS_SELECTION_TITLE;
        } else if (isEbon) {
            return i18nHome.EBON_OFFERS_SELECTION_TITLE;
        } else {
            return '';
        }
    };

    const getData = () => {
        if (isOnline) {
            // Use auto-completion algorithm for online offers
            return completeOnlineMeasWithAvailablePartners(onlineOffers, partners);
        } else if (isOffline) {
            // Use auto-completion algorithm for offline offers
            return completeOfflineMeasWithAvailablePartners(offlineOffers, partners);
        } else if (isEbon) {
            // Use auto-completion algorithm for ebon offers
            return completeEbonMeasWithAvailablePartners(ebonOffers, ebonPartners);
        } else {
            return [];
        }
    };

    const getPartner = mea => {
        if (isOnline || isOffline) {
            return partners[mea.idPartenaire] ? partners[mea.idPartenaire] : null;
        } else if (isEbon) {
            return ebonPartners.find(p => mea.idPartenaire === p.id)
                ? ebonPartners.find(p => mea.idPartenaire === p.id)
                : null;
        } else {
            return null;
        }
    };

    return (
        hasOffer() && (
            <MediaQuery query="(min-width: 768px)">
                {matches =>
                    matches && (
                        <MediaQuery query="(min-width: 768px) and (max-width: 1024px)">
                            {matches => (
                                <section className="selection-mois">
                                    <h2>{getTitle()}</h2>
                                    {ebonPartnersFetching ? (
                                        <LoadingComponent />
                                    ) : (
                                        <div
                                            className={`${
                                                matches ? 'grid-2-small-2' : 'grid-4-small-2'
                                            } has-gutter`}>
                                            {getData() &&
                                                getData().map((item, i) => {
                                                    return (
                                                        <PartnerBlockComponent
                                                            partner={getPartner(item)}
                                                            key={i}
                                                            isOffline={isOffline || item.offline}
                                                            isEbon={isEbon || item.ebon}
                                                        />
                                                    );
                                                })}
                                        </div>
                                    )}
                                </section>
                            )}
                        </MediaQuery>
                    )
                }
            </MediaQuery>
        )
    );
};

DesktopMeaOfferSelection.propTypes = {
    isOnline: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18nHome: state.i18n.page.HOME,
        onlineOffers: mea.selectors.getMeasListByTypeId(state, mea.constants.ONLINE_OFFER),
        offlineOffers: mea.selectors.getMeasListByTypeId(state, mea.constants.OFFLINE_OFFER),
        ebonOffers: mea.selectors.getMeasListByTypeId(state, mea.constants.EBON_OFFER),
        partners: state.partner.partners,
        ebonPartners: state.ebon.ebonPartners,
        ebonPartnersFetching: state.ebon.ebonPartnersFetching
    };
};

export default withRouter(connect(mapStateToProps)(DesktopMeaOfferSelection));



// WEBPACK FOOTER //
// ./src/components/pages/home/DesktopMeaOfferSelection.js